<template>
	<div>
		<headers></headers>
    <div class="titlediv">
      <span class="title">思想与品德第三次作业</span>
      <span class="prompt">本次作业共100分。选择题每小题2分，填空题每题2分，共50小题。</span>
      <div class="question">
        <span>单选题</span>
        <span>填空题</span>
        <span>多选题</span>
      </div>
    </div>
	</div>
</template>

<script>
	import headers from '../../components/headers.vue';
  import footers from '../../components/footers.vue';

	export default {
		name: 'app',
		components: {
			headers
		},
		data() {
			return {

			}
		},
		methods: {

		}
	}
</script>

<style scoped>
  html{height: 100%;}
	body {
		padding: 0px;
		margin: 0px;
    height: 100%;
    background: rgba(95,95,95,0.1);
	}

	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
    height: 100%;
	}
  .titlediv{
    width: 62%;
    height: 210px;
    margin: 0 auto;
    margin-top: 86px;
    background: #FFFFFF;
    border-radius: 8px;
  }
  .title{
    font-weight: 700;
    font-size: 25.2px;
    line-height: 35px;
    color: #171725;
  }
  .prompt{
    font-weight: 400;
    font-size: 12.6px;
    line-height: 18px;
    color: #66707A;
    display: block;
    text-align: left;
  }
  .question span{
    width: 71.8px;
    height: 27.45px;
    line-height: 27.45px;
    border: 1px solid #D1D8DD;
    border-radius: 4px;
    display: inline-block;
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/Markpaper.vue